









/* global google */
import { defineComponent, onMounted, ref, useContext, provide, computed, PropType, onBeforeUnmount } from '@nuxtjs/composition-api'
import { whenever } from '@vueuse/core'

import Coordinate from '@/interfaces/Coordinate'

export default defineComponent({
  props: {
    origin: {
      type: Object as PropType<Coordinate | null>,
      default: null,
    },
    mapOptions: {
      type: Object as PropType<google.maps.MapOptions | null>,
      default: null,
    },
    markOrigin: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const el = ref<Element | null>(null)
    const map = ref<google.maps.Map | null>(null)
    const zoom = ref<number>()

    provide('map', map)

    const init = () => {
      const center = props.origin ?? { lat: 25.0329636, lng: 121.5654268 }

      const options: google.maps.MapOptions = {
        center,
        zoom: 12,
        scrollwheel: true,
        clickableIcons: false,
        fullscreenControl: false,
        mapTypeControl: false,
        gestureHandling: 'greedy',
        zoomControlOptions: { position: 7 },
        streetViewControl: false,
        styles: require('@/assets/json/map-styles.json'),
        // components/search/SearchMap.vue:233
        // 無法真的避免過度放大, google map會直接zoom到最大 (22)
        // 我們使用情境也會不讓使用者放這麼大, 所以加 maxZoom 為18
        maxZoom: 18,
        ...props.mapOptions,
      }
      if (el.value) {
        map.value = new google.maps.Map(el.value, options)
        zoom.value = map.value.getZoom()

        if (props.markOrigin) {
          const originMarker = new google.maps.Marker({
            position: center,
            map: map.value,
          })
          originMarker.addListener('click', () => emit('origin-click'))
        }

        map.value.addListener('zoom_changed', () => {
          if (map.value!.getZoom() < zoom.value!) {
            emit('zoom-out')
          } else {
            emit('zoom-in')
          }

          zoom.value = map.value!.getZoom()
        })
        map.value.addListener('drag', () => {
          emit('drag')
        })

        emit('on-init', map.value, el.value)
      }
    }

    const { app: { store } } = useContext()

    const isGoogleLoaded = computed(() => store?.state.google.isLoaded)
    onMounted(() => whenever(isGoogleLoaded, init, { immediate: true }))

    onBeforeUnmount(() => {
      if (map.value) {
        google.maps.event.clearListeners(map.value, 'click')
      }
    })

    return {
      el,
      map,
      isGoogleLoaded,
    }
  },
})
